module.exports = __webpack_public_path__ + "static/media/closeSidebar.e247c0d3.svg";